import { motion } from 'motion/react'

import { Skeleton } from '@/components/ui/skeleton'

export const EventCardSkeleton = () => (
  <motion.div
    initial={{ opacity: 1, y: 0 }}
    animate={{ opacity: 1, y: 0 }}
    exit={{ opacity: 0, y: -16 }}
    transition={{ duration: 0.2, ease: 'easeOut' }}
  >
    <Skeleton className="h-150 w-full max-w-full rounded-2xl sm:h-75"></Skeleton>
  </motion.div>
)
